import React from "react";
import { TableHeader } from "../../../components/commons";
import { JOB_CHECKLIST_HEADER } from "../../../constant/jobs";
import JobsChecklistTableData from "./JobsChecklistTableData";
import { ChecklistItemType } from "../../../commonTypes/jobsType";

type AppProps = {
  history: any;
  data: ChecklistItemType[] | [];
  handleEditJobsChecklist: (id: string) => void;
  isEditJobChecklistPresent:boolean;
};

const JobCheckListTable = ({
  history,
  data,
  handleEditJobsChecklist,
  isEditJobChecklistPresent
}: AppProps) => {
  return (
    <div className="jobsType table">
      <table className="table thead-light table-bordered">
        <thead className="sticky-table-header">
          <TableHeader tableHeader={JOB_CHECKLIST_HEADER} />
        </thead>
        <tbody>
          <JobsChecklistTableData
            history={history}
            data={data}
            isEditJobChecklistPresent={isEditJobChecklistPresent}
            header={JOB_CHECKLIST_HEADER}
            handleEdit={handleEditJobsChecklist}
          />
        </tbody>
      </table>
    </div>
  );
};

export default JobCheckListTable;
